import { styled } from '../../../utils/styled';
import { propStyles } from '../../../utils/propStyles';
import { top, whiteSpace } from '../../../utils/customPropStyles';

const StyledComponent = styled<any, any>(
    'div',
    'dropdownMenuWrapper',
    'dropdown'
)`
    ${propStyles};
    ${top};
    ${whiteSpace};
`;

StyledComponent.defaultProps = {
    position: 'absolute',
    top: 'calc(100% + 1px)',
    zIndex: 'dropdown',
    width: ['85%', 'auto'],
    margin: ['0', '0 10%'],
    bgColor: 'white',
    borderWidth: '1px',
    borderColor: 'gray300',
    borderStyle: 'solid',
    borderRadius: 'sm',
    boxShadow: 'sm',
};

export default StyledComponent;



// WEBPACK FOOTER //
// ./src/Components/Dropdown/StyledComponents/DropdownMenuWrapper.tsx